import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { OverlayMatIconInput } from './custom-tool-tip';

@Component({
  selector: 'rpe-custom-tool-tip',
  templateUrl: './custom-tool-tip.component.html',
  styleUrls: ['./custom-tool-tip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomToolTipComponent {
  @Input() overlayInput: OverlayMatIconInput = {
    text: '',
    icon: '',
    color: 'primary',
    isOpen: false,
    isLoading: false,
    matIcon: false
  };
}
